var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobalLocalMentor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4951 22.9583C16.8726 22.9583 14.7451 25.0858 14.7451 27.7083C14.7451 30.3307 16.8726 32.4583 19.4951 32.4583C22.1176 32.4583 24.2451 30.3307 24.2451 27.7083C24.2451 25.0863 22.1176 22.9583 19.4951 22.9583Z",
    fill: "#44AB96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6621 34.8333H16.3284C14.5795 34.8333 13.1616 36.2511 13.1616 38.0001H25.8284C25.8284 36.2511 24.4125 34.8333 22.6621 34.8333Z",
    fill: "#44AB96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7451 22.9583C31.1226 22.9583 28.9951 25.0858 28.9951 27.7083C28.9951 30.3307 31.1226 32.4583 33.7451 32.4583C36.3676 32.4583 38.4951 30.3307 38.4951 27.7083C38.4951 25.0863 36.3676 22.9583 33.7451 22.9583Z",
    fill: "#44AB96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4953 34.8333H30.5785C28.8295 34.8333 27.4121 36.2511 27.4121 38.0001H38.4953V34.8333Z",
    fill: "#44AB96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.495117 27.7082C0.495117 30.3307 2.62264 32.4582 5.24512 32.4582C7.86759 32.4582 9.99512 30.3307 9.99512 27.7082C9.99512 25.0857 7.86759 22.9582 5.24512 22.9582C2.62264 22.9582 0.495117 25.0862 0.495117 27.7082Z",
    fill: "#44AB96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.495117 34.8332H8.41194C10.1609 34.8332 11.5788 36.2511 11.5788 38H0.495117V34.8332Z",
    fill: "#44AB96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99512 0C7.37264 0 5.24512 2.12753 5.24512 4.75C5.24512 7.37247 7.37264 9.5 9.99512 9.5C12.6176 9.5 14.7451 7.37247 14.7451 4.75C14.7451 2.12753 12.6176 0 9.99512 0Z",
    fill: "#44AB96"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6619 17.4168V15.0418C22.6619 12.4227 21.5951 10.0477 19.8756 8.32819L17.6369 10.564C18.784 11.7111 19.4951 13.2943 19.4951 15.0418V17.4168H16.3283V15.0418C16.3283 13.2915 14.909 11.875 13.1615 11.875H6.82829C5.07792 11.875 3.66147 13.2915 3.66147 15.0418V17.4168H0.495117V20.5837H25.8283V17.4168H22.6619Z",
    fill: "#44AB96"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2451 3.16682V7.91682C24.2451 9.65817 25.6706 11.0836 27.4119 11.0836V14.25L32.1619 11.0832H35.3283C37.0696 11.0832 38.4951 9.6577 38.4951 7.91635V3.16635C38.4951 1.42548 37.0696 0 35.3283 0H27.4119C25.6706 0 24.2451 1.42548 24.2451 3.16682Z",
    fill: "#44AB96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalLocalMentor);
export default __webpack_public_path__ + "static/media/globalLocalMentor.f71286d5acd6911a65950bca1f95ebaf.svg";
export { ForwardRef as ReactComponent };